import Select from "react-select"; // ✅
import React from "react";
import { Controller } from "react-hook-form";

const CaseBasicInfo = ({
  control,
  errors,
  lang,
  enPhrase,
  arPhrase,
  isLoading,
  isRtl,
  isSearchable,
  courts,
  caseTypes,
  years,
  partyTypes,
  sharedValues,
  setSharedValues,
  clearErrors,
  register,
  CustomDropdownIndicator,
  formatOptionLabel,
  optionsYear,
}) => {
  function customTheme(theme) {
    return {
      ...theme,
      colors: {
        ...theme.colors,
        primary25: "#F9F7ED",
        primary: "#B68A35",
        neutral0: "white", // Ensure menu background stays white
      },
    };
  }

  const customStyles = {
    control: (base, state) => ({
      ...base,
      background: state.isDisabled ? "#EFEFEF" : "#fff", // gray background when disabled
      borderRadius: 4,
      "*": {
        boxShadow: "none !important",
      },
      backgroundColor: state.isFocused ? "#fffff0" : "#fff",
    }),
    menu: (base) => ({
      ...base,
      borderRadius: 0,
      marginTop: 0,
      height: "auto",
      overflow: "auto",
    }),
    menuList: (base) => ({
      ...base,
      padding: 0,
      backgroundColor: "#fff", // Keep background white to avoid overriding
      maxHeight: "200px",
    }),
    option: (base, { isSelected, isFocused }) => ({
      ...base,
      backgroundColor: isSelected ? "#B68A35" : isFocused ? "#F9F7ED" : "white",
      color: isSelected ? "white" : "black",
      ":hover": {
        backgroundColor: isSelected ? "#B68A35" : "#F9F7ED",
        color: "black",
      },
    }),
    indicatorSeparator: (base) => ({
      ...base,
      display: "none",
    }),
  };

  return (
    <div className="w-full xl:w-[384px] min-h-[484px] bg-[#fff] border-[0.5px] border-[#EEE2D0] shadow-[0px_10px_40px_#361E1214] rounded-[16px] py-[24px] gap-[24px]">
      <div className="flex flex-row gap-[24px] mb-[24px]">
        <img
          src="/assets/img/add-request/Rectangle.svg"
          alt="icon"
          className={`${lang === "en" ? "rotate-180" : ""}`}
        />
        <div className="flex flex-col">
          <p className="font-Almarai font-bold text-[14px] leading-[20px] text-[#0E0D0C]">
            {lang === "en"
              ? enPhrase["lblCaseDetails"]
              : arPhrase["lblCaseDetails"]}
          </p>
          <p className="font-Almarai font-400 text-[11px] leading-[18px] text-[#6F6A62]">
            {lang === "en"
              ? enPhrase["lblBasicInfo"]
              : arPhrase["lblBasicInfo"]}
          </p>
        </div>
      </div>

      <div className="px-[24px] flex flex-col gap-[16px]">
        <div>
          <label
            htmlFor="court"
            className={`block text-[12px] ${
              errors.court
                ? " text-[#E61A05] font-normal"
                : "text-gray-700 font-bold"
            }`}
          >
            {lang === "en" ? enPhrase["lblCourt"] : arPhrase["lblCourt"]}
          </label>
          <Controller
            name="court"
            rules={{
              required: "court is required",
            }}
            control={control}
            render={({ field }) => (
              <Select
                components={{
                  DropdownIndicator: CustomDropdownIndicator,
                }}
                theme={customTheme}
                styles={customStyles}
                noOptionsMessage={() =>
                  lang === "en"
                    ? enPhrase["lblNoResultFound"]
                    : arPhrase["lblNoResultFound"]
                }
                placeholder={
                  <div className="text-gray-600 text-sm">
                    {lang === "en"
                      ? enPhrase["lblCourtType"]
                      : arPhrase["lblCourtType"]}
                  </div>
                }
                label="court"
                error={false}
                {...field}
                classNames={{
                  control: () =>
                    `mt-1 border border-gray-300 text-black focus:!bg-gold-10 !rounded-lg text-[12px] ${
                      errors.court ? "!border-red-600" : "!border-gray-300"
                    }`,
                }}
                classNamePrefix="select"
                defaultValue={courts[0]}
                isLoading={isLoading}
                isRtl={isRtl}
                isSearchable={isSearchable}
                name="caseType"
                options={courts}
                getOptionLabel={(options) => options["name"]}
                getOptionValue={(options) => options["id"]}
                formatOptionLabel={formatOptionLabel}
                onChange={(selected) => {
                  field.onChange(selected); // Ensure React Hook Form tracks changes
                  setSharedValues((prev) => ({
                    ...prev,
                    court: selected,
                  }));
                  clearErrors("court");
                }}
              />
            )}
          />
          {errors.court && (
            <span role="alert" className=" text-xs text-red-600">
              {lang === "en"
                ? enPhrase["drpdwn_Court_error"]
                : arPhrase["drpdwn_Court_error"]}
            </span>
          )}
        </div>
        <div>
          <label
            htmlFor="caseType"
            className={`block text-[12px]  ${
              errors.caseType
                ? " text-[#E61A05] font-normal"
                : "text-gray-700 font-bold"
            }`}
          >
            {lang === "en" ? enPhrase["lblCaseType"] : arPhrase["lblCaseType"]}
          </label>

          <Controller
            name="caseType"
            rules={{
              required: "Case Type is required",
            }}
            control={control}
            render={({ field }) => (
              <Select
                components={{
                  DropdownIndicator: CustomDropdownIndicator,
                }}
                theme={customTheme}
                styles={customStyles}
                noOptionsMessage={() =>
                  lang === "en"
                    ? enPhrase["lblNoResultFound"]
                    : arPhrase["lblNoResultFound"]
                }
                placeholder={
                  <div className="text-gray-600 text-sm">
                    {lang === "en"
                      ? enPhrase["lblCasePalceHolder"]
                      : arPhrase["lblCasePalceHolder"]}
                  </div>
                }
                label="caseType"
                error={false}
                {...field}
                classNames={{
                  control: () =>
                    `mt-1 border border-gray-300 text-black focus:!bg-gold-10 !rounded-lg text-[12px] ${
                      errors.caseType ? "!border-red-600" : "!border-gray-300"
                    }`,
                }}
                classNamePrefix="select"
                defaultValue={caseTypes[0]}
                isLoading={isLoading}
                isRtl={isRtl}
                isSearchable={isSearchable}
                name="caseType"
                options={caseTypes}
                getOptionLabel={(options) => options["name"]}
                getOptionValue={(options) => options["id"]}
                formatOptionLabel={formatOptionLabel}
                filterOption={(candidate, input) =>
                  candidate.data.nameForSearch
                    .toLowerCase()
                    .includes(input.toLowerCase())
                } // Search by "nameForSearch"
                onChange={(selected) => {
                  field.onChange(selected);
                  setSharedValues((prev) => ({
                    ...prev,
                    caseType: selected,
                  }));
                  clearErrors("caseType");
                }}
              />
            )}
          />

          {errors.caseType && (
            <span role="alert" className=" text-xs text-red-600">
              {lang === "en"
                ? enPhrase["lbl_Error_Case_Type"]
                : arPhrase["lbl_Error_Case_Type"]}
            </span>
          )}
        </div>

        <div className="col-span-6 sm:col-span-2">
          <div>
            <label
              htmlFor="caseNumber"
              className={`block text-[12px]  ${
                errors.caseNumber
                  ? " text-[#E61A05] font-normal"
                  : "text-gray-700 font-bold"
              }`}
            >
              {lang === "en"
                ? enPhrase["lblCaseNumber"]
                : arPhrase["lblCaseNumber"]}
            </label>
            <input
              type="text"
              name="caseNumber"
              key="caseNumber"
              placeholder={
                lang === "en"
                  ? enPhrase["lblCaseNumberHolder"]
                  : arPhrase["lblCaseNumberHolder"]
              }
              aria-invalid={errors.caseNumber ? "true" : "false"}
              {...register("caseNumber", {
                required: true,
                onChange: (e) => {
                  clearErrors("caseNumber"); // ✅ Clears error
                  setSharedValues((prev) => ({
                    ...prev,
                    caseNumber: e.target.value, // ✅ Updates state
                  }));
                },
              })}
              className={`mt-1 block w-full rounded-md h-[40px] shadow-sm focus:border-gold-100 focus:ring-gold-100 !text-[14px] sm:text-sm leading-[20px] ${
                errors.caseNumber ? " border-red-600" : " border-gray-300"
              }`}
            />
            {errors.caseNumber && (
              <span role="alert" className=" text-xs text-red-600">
                {lang === "en"
                  ? enPhrase["lbl_Case_Number_Error"]
                  : arPhrase["lbl_Case_Number_Error"]}
              </span>
            )}
          </div>
        </div>

        <div className="col-span-6 sm:col-span-2">
          <div>
            <label
              htmlFor="caseYear"
              className={`block text-[12px]  ${
                errors.caseYear
                  ? " text-[#E61A05] font-normal"
                  : "text-gray-700 font-bold"
              }`}
            >
              {lang === "en" ? enPhrase["lblYear"] : arPhrase["lblYear"]}
            </label>

            <Controller
              name="caseYear"
              rules={{
                required: "case Year is required",
              }}
              control={control}
              render={({ field }) => (
                <Select
                  components={{
                    DropdownIndicator: CustomDropdownIndicator,
                  }}
                  theme={customTheme}
                  styles={customStyles}
                  noOptionsMessage={() =>
                    lang === "en"
                      ? enPhrase["lblNoResultFound"]
                      : arPhrase["lblNoResultFound"]
                  }
                  placeholder={
                    <div className="text-gray-600 text-sm">
                      {lang === "en"
                        ? enPhrase["lblYearHolder"]
                        : arPhrase["lblYearHolder"]}
                    </div>
                  }
                  label="caseYear"
                  error={false}
                  {...field}
                  classNames={{
                    control: () =>
                      `mt-1 border border-gray-300 text-black focus:!bg-gold-10 !rounded-lg text-[12px] ${
                        errors.caseYear ? "!border-red-600" : "!border-gray-300"
                      }`,
                  }}
                  classNamePrefix="select"
                  defaultValue={optionsYear[0]}
                  isLoading={isLoading}
                  isRtl={isRtl}
                  isSearchable={isSearchable}
                  name="caseYear"
                  options={optionsYear}
                  getOptionLabel={(options) => options["name"]}
                  getOptionValue={(options) => options["id"]}
                  formatOptionLabel={formatOptionLabel}
                  onChange={(selected) => {
                    field.onChange(selected);
                    setSharedValues((prev) => ({
                      ...prev,
                      caseYear: selected,
                    }));
                    clearErrors("caseYear");
                  }}
                />
              )}
            />

            {errors.caseYear && (
              <span role="alert" className=" text-xs text-red-600">
                {lang === "en"
                  ? enPhrase["lbl_Error_Case_Year"]
                  : arPhrase["lbl_Error_Case_Year"]}
              </span>
            )}
          </div>
        </div>

        <div className="col-span-6 sm:col-span-2">
          <label
            htmlFor="customer"
            className={`block text-[12px]  ${
              errors.customer
                ? " text-[#E61A05] font-normal"
                : "text-gray-700 font-bold"
            }`}
          >
            {lang === "en" ? enPhrase["lblUserType"] : arPhrase["lblUserType"]}
          </label>

          <Controller
            name="customer"
            rules={{
              required: "party Types is required",
            }}
            control={control}
            render={({ field }) => (
              <Select
                components={{
                  DropdownIndicator: CustomDropdownIndicator,
                }}
                theme={customTheme}
                styles={customStyles}
                noOptionsMessage={() =>
                  lang === "en"
                    ? enPhrase["lblNoResultFound"]
                    : arPhrase["lblNoResultFound"]
                }
                placeholder={
                  <div className="text-gray-600 text-sm">
                    {lang === "en"
                      ? enPhrase["lblUserTypeHolder"]
                      : arPhrase["lblUserTypeHolder"]}
                  </div>
                }
                label="customer"
                error={false}
                {...field}
                classNames={{
                  control: () =>
                    `mt-1 border border-gray-300 text-black focus:!bg-gold-10 !rounded-lg text-[12px] ${
                      errors.customer ? "!border-red-600" : "!border-gray-300"
                    }`,
                }}
                classNamePrefix="select"
                defaultValue={partyTypes[0]}
                isLoading={isLoading}
                isRtl={isRtl}
                isSearchable={isSearchable}
                name="customer"
                options={partyTypes}
                getOptionLabel={(options) => options["name"]}
                getOptionValue={(options) => options["id"]}
                formatOptionLabel={formatOptionLabel}
                filterOption={(candidate, input) =>
                  candidate.data.nameForSearch
                    .toLowerCase()
                    .includes(input.toLowerCase())
                } // Search by "nameForSearch"
                onChange={(selected) => {
                  field.onChange(selected);
                  setSharedValues((prev) => ({
                    ...prev,
                    customer: selected,
                  }));
                  clearErrors("customer");
                }}
              />
            )}
          />

          {errors.customer && (
            <span role="alert" className=" text-xs text-red-600">
              {lang === "en"
                ? enPhrase["lblUserTypeError"]
                : arPhrase["lblUserTypeError"]}
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default CaseBasicInfo;
